import { useEffect } from 'react';
import { editorViewCtx } from '@milkdown/kit/core';
import { useInstance } from '@milkdown/react';

import { reviewSuggestionsDecoKey, reviewSuggestionsSelectionMeta } from './plugin';

/**
 * Keeps the ProseMirror decoration plugin's selected id aligned with the
 * React-owned right-rail selection state.
 */
export function useReviewSuggestionSelectionSync(selectedReviewSuggestionId: string | null | undefined): void {
  const [loadingInstance, getInstance] = useInstance();

  useEffect(() => {
    if (loadingInstance) return undefined;

    let cancelled = false;

    queueMicrotask(() => {
      if (cancelled) return;
      const editor = getInstance();
      if (!editor) return;

      try {
        editor.action((ctx) => {
          const view = ctx.get(editorViewCtx);
          const tr = view.state.tr.setMeta(reviewSuggestionsDecoKey, reviewSuggestionsSelectionMeta(selectedReviewSuggestionId));
          view.dispatch(tr);
        });
      } catch {
        // Editor contexts may be unavailable between Milkdown instances.
      }
    });

    return () => {
      cancelled = true;
    };
  }, [getInstance, loadingInstance, selectedReviewSuggestionId]);
}
